import { Ce } from './Ce';

class TrainingPlanTemplateDetail extends Ce {
    constructor() {
        super();
        this.baseUrl += '/trainingPlanTemplateDetail';
    }

    /**
     * 根据培训计划模板ID选择培训计划模板详情
     *
     * @param trainingPlanTemplateId
     * @returns {AxiosPromise<*>}
     */
    selectDetailListByProgram({ trainingPlanTemplateId } = {}) {
        return super.get('/selectDetailListByProgram', {
            trainingPlanTemplateId,
        });
    }
}
export default new TrainingPlanTemplateDetail();
export { TrainingPlanTemplateDetail };
